export const isRolledTypedDate = (date, wrapper) => {
  const input = document.activeElement;
  if (!wrapper?.contains(input) || !['day', 'month', 'year'].includes(input.name)) return false;
  const parts = Object.fromEntries(
    [...wrapper.querySelectorAll('input[name="day"], input[name="month"], input[name="year"]')].map(
      (el) => [el.name, Number(el.value)]
    )
  );
  return (
    date.getDate() !== parts.day ||
    date.getMonth() + 1 !== parts.month ||
    date.getFullYear() !== parts.year
  );
};
